export const medicalAndPreventiveCareConst = {
  path: "/single-programs/medical-and-preventive-care",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — МЕДИКО-ПРОФИЛАКТИЧЕСКОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Медико-профилактическое дело — медицина, которая предотвращает болезни</h2>
      <p>
        Медико-профилактическое дело — это ключевое направление современной медицины, направленное на сохранение и укрепление общественного
        здоровья. Вместо лечения последствий — работа с причинами. Это профессия для тех, кто хочет влиять на здоровье целых сообществ и
        предотвращать вспышки заболеваний до их начала.
      </p>
      <p>
        Программа сочетает медицинскую подготовку с углублённым изучением эпидемиологии, санитарии, гигиены и организации здравоохранения.
        Выпускники становятся специалистами, способными разрабатывать и внедрять эффективные меры профилактики и контроля.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Гигиена и санитария</li>
        <li>Эпидемиология и инфекционные болезни</li>
        <li>Общественное здоровье и медицинская статистика</li>
        <li>Микробиология, вирусология, паразитология</li>
        <li>Экология человека и охрана окружающей среды</li>
        <li>Организация здравоохранения и профилактики</li>
        <li>Медицинское право и международные регламенты</li>
        <li>Методология профилактических программ и скрининга</li>
        <li>Управление санитарными службами и контроль рисков</li>
      </ul>
      <p>
        Учебный план включает практику в санитарно-эпидемиологических учреждениях, центрах общественного здоровья, лабораториях и
        международных организациях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-эпидемиолог</li>
        <li>Специалист по санитарному контролю и гигиене</li>
        <li>Эксперт по инфекционным заболеваниям и профилактике</li>
        <li>Специалист в государственных и международных структурах здравоохранения</li>
        <li>Консультант по общественному здоровью</li>
        <li>Преподаватель или научный сотрудник</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Профилактика — приоритет для всех современных систем здравоохранения.</p>
      <p>
        <strong>Средний доход специалистов в Европе — от €40,000 до €75,000 в год,</strong> особенно в структурах ЕС и ВОЗ.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Очная и дистанционная формы обучения</li>
        <li>Практика и стажировки в структурах общественного здоровья</li>
        <li>Возможность работать в сфере глобального здравоохранения</li>
        <li>Программы на русском и английском языках</li>
        <li>Поддержка студентов в научной и профессиональной деятельности</li>
      </ul>
      <h2>Учёба, направленная на здоровье общества</h2>
      <p>
        Наши студенты принимают участие в исследованиях, санитарных кампаниях и профилактических проектах, а также представляют университет
        на международных форумах в сфере здравоохранения.
      </p>
      <br />
      <p className="padding-left">
        «Медико-профилактическое дело — это медицина будущего. Мы обучаем тех, кто делает здоровье доступным и устойчивым.»
      </p>
      <h2>Как поступить?</h2>
      <p>Процесс поступления максимально простой:</p>
      <p>
        заполните онлайн-анкету, прикрепите документы — и дождитесь обратной связи. Приёмная комиссия поможет сориентироваться на каждом
        этапе.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Медико-профилактическое дело — медицина, которая предотвращает болезни
    Медико-профилактическое дело — это ключевое направление современной медицины, направленное на сохранение и укрепление общественного здоровья. Вместо лечения последствий — работа с причинами. Это профессия для тех, кто хочет влиять на здоровье целых сообществ и предотвращать вспышки заболеваний до их начала.
    Программа сочетает медицинскую подготовку с углублённым изучением эпидемиологии, санитарии, гигиены и организации здравоохранения. Выпускники становятся специалистами, способными разрабатывать и внедрять эффективные меры профилактики и контроля.

    Что вы будете изучать?
    • Гигиена и санитария
    • Эпидемиология и инфекционные болезни
    • Общественное здоровье и медицинская статистика
    • Микробиология, вирусология, паразитология
    • Экология человека и охрана окружающей среды
    • Организация здравоохранения и профилактики
    • Медицинское право и международные регламенты
    • Методология профилактических программ и скрининга
    • Управление санитарными службами и контроль рисков
    Учебный план включает практику в санитарно-эпидемиологических учреждениях, центрах общественного здоровья, лабораториях и международных организациях.

    Кем можно работать после окончания?
    • Врач-эпидемиолог
    • Специалист по санитарному контролю и гигиене
    • Эксперт по инфекционным заболеваниям и профилактике
    • Специалист в государственных и международных структурах здравоохранения
    • Консультант по общественному здоровью
    • Преподаватель или научный сотрудник

    Востребованность и доход
    Профилактика — приоритет для всех современных систем здравоохранения.
    Средний доход специалистов в Европе — от €40,000 до €75,000 в год, особенно в структурах ЕС и ВОЗ.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Очная и дистанционная формы обучения
    • Практика и стажировки в структурах общественного здоровья
    • Возможность работать в сфере глобального здравоохранения
    • Программы на русском и английском языках
    • Поддержка студентов в научной и профессиональной деятельности

    Учёба, направленная на здоровье общества
    Наши студенты принимают участие в исследованиях, санитарных кампаниях и профилактических проектах, а также представляют университет на международных форумах в сфере здравоохранения.
    «Медико-профилактическое дело — это медицина будущего. Мы обучаем тех, кто делает здоровье доступным и устойчивым.»

    Как поступить?
    Процесс поступления максимально простой:
    заполните онлайн-анкету, прикрепите документы — и дождитесь обратной связи. Приёмная комиссия поможет сориентироваться на каждом этапе.
  `,
};
